import './Home.scss';
import React, { useEffect } from "react";
import WellnessLeader from "./Content/WellnessLeader/WellnessLeader";
import HowItWorks from "./Content/HowItWorks/HowItWorks";
import GetStarted from './Content/GetStarted/GetStarted';
import BuildSection from "./Content/WellnessIndustry/WellnessIndustry";
import Pricing from "./Content/Pricing/Pricing";
import SucceessStories from "./Content/SuccessStories/SuccessStories";
import AppSection from "./Content/AppSection/AppSection";
import { Link } from 'react-router-dom';


const Home: React.FC = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.location.hash.includes('landingPricing')) {
      const availabilitySectionNode = document.getElementById('landingPricing')

      availabilitySectionNode
        && availabilitySectionNode.scrollIntoView(true)
    }
  }, [])

  return (
    <div className="home-div">
      <WellnessLeader />
      <BuildSection />
      <HowItWorks />
      <AppSection />
      <SucceessStories />          
      <Pricing />
      <GetStarted />
    </div>
  );
};

export default Home;
